import React from 'react';
import { connectHighlight } from 'react-instantsearch-dom';

const Snippet = ({ highlight, attribute, hit, className }) => {
  const parsedHit = highlight({
    highlightProperty: '_snippetResult',
    attribute,
    hit
  });
  return (
    <span className={className}>
      {parsedHit.map((part, index) => {
        return part.isHighlighted ? (
          <mark key={index}>{part.value}</mark>
        ) : (
          <span key={index}>{part.value}</span>
        );
      })}
    </span>
  );
};

export default connectHighlight(Snippet);